exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".settings-panel h2 {\n  margin-bottom: 30px; }\n\n.settings-panel input {\n  height: 70px;\n  font-size: 22px;\n  color: #757373;\n  border: 1.5px solid #ced4da; }\n\n.settings-panel button {\n  font-size: 22px;\n  background-color: #4ec8ed;\n  height: 70px;\n  width: 400px;\n  border: none; }\n\n.pword-vis {\n  position: relative;\n  left: 90%;\n  bottom: 45px;\n  color: #757373; }\n", ""]);

// exports
